/**
 * Returns an experience id for a given url
 *
 * @param {string} url
 * @returns {string}
 */
export default function getExperienceId(url) {
  if (url.endsWith("/")) {
    // eslint-disable-next-line no-param-reassign
    url = url.slice(0, -1);
  }

  return url.split("/").pop();
}
